import { useRef } from 'react';

import { TradingCompetition } from '@flipster/apis/v1/tradingCompetition/types';
import { observeIntersectionOnce, useIntersection } from '@flipster/react/misc/browser/intersection';
import { useBreakpoint } from '@flipster/react/misc/responsive/index';
import { center } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { CompetitionsEvent } from '@flipster/utils/segment/events/competitions';

export const BannerSection = ({ competition }: { competition: TradingCompetition }) => {
  const bannerRef = useRef<HTMLElement>(null);
  useIntersection(
    bannerRef,
    observeIntersectionOnce(() => {
      segment.track(CompetitionsEvent.CompetitionLandingViewPageScroll, {
        section_title: 'Banner',
      });
    }),
  );
  const isVideoBanner = competition.bannerUrls.desktop.includes('.mp4');
  const { isMobile } = useBreakpoint();
  return (
    <section
      className={center({
        overflow: 'hidden',
        '& :is(img, video)': {
          tabletDown: {
            w: '100%',
            aspectRatio: '960 / 450',
          },
          tablet: { h: 400 },
          smallDesktop: { h: 600 },
        },
      })}
      ref={bannerRef}
      style={{ backgroundColor: 'var(--banner-bg-color)' }}
    >
      {isVideoBanner ? (
        <video
          playsInline
          autoPlay
          muted
          loop
          src={isMobile ? competition.bannerUrls.mobile : competition.bannerUrls.desktop}
        >
          <track kind='captions' />
        </video>
      ) : (
        <img
          src={isMobile ? competition.bannerUrls.mobile : competition.bannerUrls.desktop}
          alt='trading-competition-banner'
        />
      )}
    </section>
  );
};
